module.exports = __webpack_public_path__ + "static/media/coverage_plan.ddf965e8.pdf";